var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.935 21.529 H 62.15 c -2.616 0 -4.745 -2.128 -4.745 -4.745 V 2 h 4 v 14.784 c 0 0.411 0.334 0.745 0.745 0.745 h 14.784 V 21.529 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.922 90 H 16.078 c -2.764 0 -5.013 -2.249 -5.013 -5.013 V 5.013 C 11.065 2.249 13.314 0 16.078 0 h 42.079 c 1.339 0 2.598 0.521 3.545 1.467 l 15.765 15.766 c 0.946 0.947 1.468 2.206 1.468 3.544 v 64.21 C 78.935 87.751 76.686 90 73.922 90 z M 16.078 4 c -0.559 0 -1.013 0.454 -1.013 1.013 v 79.975 c 0 0.559 0.455 1.013 1.013 1.013 h 57.844 c 0.559 0 1.013 -0.454 1.013 -1.013 v -64.21 c 0 -0.271 -0.105 -0.525 -0.297 -0.717 L 58.874 4.296 C 58.683 4.105 58.428 4 58.157 4 H 16.078 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 60.992 c -3.391 0 -6.15 -2.759 -6.15 -6.15 V 28.317 c 0 -3.391 2.759 -6.15 6.15 -6.15 c 3.392 0 6.15 2.759 6.15 6.15 v 26.525 C 51.15 58.233 48.392 60.992 45 60.992 z M 45 26.167 c -1.186 0 -2.15 0.965 -2.15 2.15 v 26.525 c 0 1.186 0.965 2.15 2.15 2.15 s 2.15 -0.965 2.15 -2.15 V 28.317 C 47.15 27.131 46.186 26.167 45 26.167 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 75.651 c -3.391 0 -6.15 -2.759 -6.15 -6.15 s 2.759 -6.15 6.15 -6.15 c 3.392 0 6.15 2.759 6.15 6.15 S 48.392 75.651 45 75.651 z M 45 67.351 c -1.186 0 -2.15 0.965 -2.15 2.15 s 0.965 2.15 2.15 2.15 s 2.15 -0.965 2.15 -2.15 S 46.186 67.351 45 67.351 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataSvg);
export default __webpack_public_path__ + "static/media/noDataSVG.f18909f763c801bfc4fdbd73ccf34b80.svg";
export { ForwardRef as ReactComponent };